<template>
  <nav class="
      px-4
      py-3
      flex
      items-center
      justify-between
      border-t border-gray-200
      sm:px-6
    " aria-label="Pagination">
    <div class="hidden sm:block">
      <p class="text-sm text-gray-700">
        Mostrando
        {{ " " }}
        <span class="font-medium">{{ meta.from }}</span>
        {{ " " }}
        a
        {{ " " }}
        <span class="font-medium">{{ meta.to }}</span>
        {{ " " }}
        de
        {{ " " }}
        <span class="font-medium">{{ meta.total }}</span>
        {{ " " }}
        resultados
      </p>
    </div>
    <div class="flex-1 flex justify-between sm:justify-end">
      <button aria-label="Primera página" class="
          btn btn-outline-secondary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        " @click="firstPage" :disabled="this.page <= 1 || fetching">
        <i class="fas fa-angle-double-left" aria-hidden="true" id="tooltip1"></i>
      </button>
      <b-tooltip target="tooltip1" placement="bottom">Primera Página</b-tooltip>
      <button aria-label="Anterior" class="
          btn btn-outline-primary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        " @click="prev" :disabled="this.page <= 1 || fetching">
        <i class="fas fa-angle-left" aria-hidden="true"  id="tooltip2"></i>
      </button>
      <b-tooltip target="tooltip2" placement="bottom">Anterior</b-tooltip>
      <button aria-label="Siguiente" @click="next" class="
          btn btn-outline-primary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        " :disabled="this.page >= this.meta.last_page || fetching">
        <i class="fas fa-angle-right" aria-hidden="true"  id="tooltip3"></i>
      </button>
      <b-tooltip target="tooltip3" placement="bottom">Siguiente</b-tooltip>
      <button aria-label="Última página" @click="lastPage" class="
          btn btn-outline-secondary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        " :disabled="this.page >= this.meta.last_page || fetching" >
        <i class="fas fa-angle-double-right" aria-hidden="true" id="tooltip4"></i>
      </button>
      <b-tooltip target="tooltip4" placement="bottom">Última Página</b-tooltip>
    </div>
  </nav>
</template>

<script>
import CompanySSOAPI from "@/services/sso/company/companySSO.API"
import CompanyAPI from "../services/company/companyAPI";
import authHeader from "../services/sso/headers";
export default {
  props: {
    link: {
      type: String,
      default: "/",
    },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fetching: false,
      meta: {
        from: 0,
        to: 0,
        total: 0,
        current_page: 1,
        last_page: 1,
      },
      page: 1,

      // Cache para roles asignados (Cliente Admin / Talento Humano /
      // Responsable Operativo): empresas asignadas ya enriquecidas con el SSO.
      assignedLoaded: false,
      assignedFull: [],
    };
  },
  computed: {
    getPage() {
      return this.page
    },
    getSearch() {
      return this.search
    }
  },
  created() {
    this.query();
  },
  methods: {
    async query() {
      this.fetching = true;
      try {
        const info = JSON.parse(localStorage.getItem("info")) || {};
        // Roles asignados via SST (Cliente Admin=6 / Talento Humano=7 /
        // Responsable Operativo=8): la lista es solo las empresas asignadas en
        // el SST (tabla company_users), no todo el catalogo del SSO.
        if ([6, 7, 8].includes(Number(info.role))) {
          await this.queryAssigned(info);
          return;
        }

        let response = await CompanySSOAPI.getCompaniesBySearch(this.page, this.search)
        let data = response
        let ssoList = response.data;

        this.meta = data.meta
          ? {
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
            current_page: data.meta.current_page,
            last_page: data.meta.last_page,
          }
          : {
            from: data.from || 0,
            to: data.to || 0,
            total: data.total || 0,
            current_page: data.current_page,
            last_page: data.last_page,
          };

        CompanyAPI.getAllCompanies()
          .then((res) => {
            let sstList = res.companies || [];

            let list = [];

            list = ssoList.map((sso) => {
              let sst = sstList.find((item) => item.uuid == sso.id) || {
                uuid: sso.id,
                legal_representative: null,
                legal_representative_email: null,
                arl_id: null,
                company_classification_id: 5,
              };
              // El social_reason real vive en el SSO; el del SST (columna nueva)
              // puede venir null y NO debe pisarlo.
              return { ...sso, ...sst, social_reason: sst.social_reason || sso.social_reason };
            });

            this.$emit("fetch", list);

            this.fetching = false;
            this.$emit("loading", false)
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Lista las empresas asignadas a un rol SST (6/7/8). Trae las asignadas
     * desde el SST (by-user-sst) y las enriquece con la data completa del SSO
     * (NIT, direccion, nombre comercial, etc.). El set asignado es pequeño, asi
     * que se carga una vez y se busca/pagina en cliente.
     */
    async queryAssigned(info) {
      try {
        if (!this.assignedLoaded) {
          const resp = await CompanyAPI.getCompaniesByUserSst(info.sstID);
          const assigned = (resp && resp.data) || [];

          this.assignedFull = await Promise.all(
            assigned.map(async (c) => {
              let sso = {};
              try {
                sso = (await CompanySSOAPI.getCompany(c.uuid)) || {};
              } catch (e) {
                sso = {};
              }
              // Quitamos social_reason/dv sinteticos de by-user-sst para no
              // pisar los reales del SSO; el resto de campos SST (id, uuid,
              // legal_representative, arl_id, clasificacion) si tienen prioridad.
              const sstRest = { ...c };
              delete sstRest.social_reason;
              delete sstRest.dv;
              // social_reason real del SSO; si el SSO no respondio, cae al de
              // by-user-sst (persistido o "Empresa #id").
              return { ...sso, ...sstRest, social_reason: sso.social_reason || c.social_reason };
            })
          );
          this.assignedLoaded = true;
        }

        // Busqueda local sobre el set asignado.
        const term = (this.search || "").toLowerCase().trim();
        let filtered = this.assignedFull;
        if (term) {
          filtered = filtered.filter(
            (c) =>
              (c.social_reason || "").toLowerCase().includes(term) ||
              (c.legal_representative || "").toLowerCase().includes(term) ||
              String(c.nit || "").toLowerCase().includes(term)
          );
        }

        // Paginacion local (10 por pagina).
        const perPage = 10;
        const total = filtered.length;
        const last = Math.max(1, Math.ceil(total / perPage));
        if (this.page > last) this.page = last;
        const start = (this.page - 1) * perPage;
        const slice = filtered.slice(start, start + perPage);

        this.meta = {
          from: total ? start + 1 : 0,
          to: start + slice.length,
          total,
          current_page: this.page,
          last_page: last,
        };

        this.$emit("fetch", slice);
        this.fetching = false;
        this.$emit("loading", false);
      } catch (error) {
        console.log(error);
        this.fetching = false;
        this.$emit("loading", false);
      }
    },

    firstPage() {
      if (this.page > 1) {
        this.page = 1;
        this.query();
      }
    },
    lastPage() {
      if (this.page < this.meta.last_page) {
        this.page = this.meta.last_page;
        this.query();
      }
    },
    next() {
      if (this.page < this.meta.last_page) {
        this.page++;
        this.query();
      }
    },
    prev() {
      if (this.page > 1) {
        this.page--;
        this.query();
      }
    },
  },
};
</script>
